import { useEffect, useState } from "react";
import "./MenuLine.css";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useMenuBar } from "../../contexts/menuBar";

const MenuLine = ({ size = 'm', ...props }) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const { t } = useTranslation();
	const { showIndexes } = useMenuBar();

	const hasSubmenu = props.submenu?.length > 0;

	function onClick(e) {
		setIsExpanded(prev => !prev);
	}

	useEffect(() => {
		if (props.submenu) {
			setIsExpanded(prev => {
				if (props.submenu.some(item => item.route === props.pageSelected || item.routes?.some(r => props.pageSelected.startsWith(r)))) {
					return true;
				}
				return prev;
			});
		}
	}, [
		props.submenu,
		props.pageSelected
	]);

	return (
		<div className="flex flex-col gap-0 relative h-fit">
			<button
				type="button"
				onClick={hasSubmenu ? onClick : e => props.handleClick(props.route)}
				className={`
					${(isExpanded || props.pageSelected === props.route || (props.routes && props.routes.some(route => props.pageSelected.startsWith(route))))
						? "sidenav-line sidenav-line-selected"
						: "sidenav-line"}
					${size === 's' ? 'px-3! py-1.5!' : ''}	
					${isExpanded ? 'bg-(--primaryColor)! **:text-white! shadow-(--box-shadow)!' : ''}
					box-border!
				`}
				data-disabled={props.disabled ?? false}
				data-title={props.title}
			>
				<span className="flex flex-row items-center justify-between w-full">
					<span className="flex flex-row gap-3.75 items-center">
						{props.icon}
						{props.navWidth === "286px" && (
							<span className={`sidenav-span ${size === 's' ? 'text-[0.78rem]! opacity-90' : ''}`}>
								{(showIndexes && (props.groupIndex || props.index)) && (
									<>
										{`${props.groupIndex ? props.groupIndex : ''}${props.groupIndex && props.index ? '.' : ''}${props.index ? props.index : ''}. `}
									</>
								)}
								{props.title}
							</span>
						)}
					</span>
					{hasSubmenu && (
						<ChevronDown size={12} className={`transition-transform mr-2! duration-200 ${!isExpanded ? '-rotate-90' : ''}`} />
					)}
				</span>
			</button>
			{isExpanded && (
				<>
					<div
						style={{
							'--subitemsQt': props.submenu?.length ?? 0,
							'--subitemHeight': '32px',
						}}
						className="absolute left-[20px] top-[41px]! w-[2px] bg-(--borderColor) h-[calc((var(--subitemHeight)*var(--subitemsQt))-2px+var(--subitemHeight)/2)] opacity-60"
					>
						<div className="absolute w-[10px] h-[4px] border-b-[2px]! border-l-[2px]! border-(--borderColor)! rounded-bl-(--borderRadius)! left-0 -translate-y-1/2 top-[calc(100%+2px)]!"></div>
					</div>
					<div className="flex flex-col gap-1 pl-8! mt-1! mb-1.5!">
						{props.submenu?.map((item, index) => (
							<MenuLine
								key={index}
								index={index + 1}
								groupIndex={props.groupIndex}
								title={t(item.title)}
								route={item.route}
								routes={item.routes}
								submenu={item.submenu}
								handleClick={(route) => {
									props.handleClick(route ?? item.route);
								}}
								icon={item.icon}
								navWidth={props.navWidth}
								pageSelected={props.pageSelected}
								size={'s'}
								disabled={item.selectedUnit === true && props.backup && (props.backup.currentStage < props.backup.totalImportingStages)}
							/>
						))}
					</div>
				</>
			)}
		</div>
	);
};

export default MenuLine;
